@if (items() && formControl()) {
<div class="prototype-picker form-group" [formGroup]="formGroup()!">
    <div class="search">
        <mat-form-field class="form-field">
            <input #search matInput [readonly]="meta()?.disabled || meta()?.readonly" [placeholder]="$safeNavigationMigration(meta()?.name)"
                class="form-control input-date" [formControl]="formControl()!" [matAutocomplete]="auto">
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onPick($event)">
                @for (group of filtered | async; track group.key) {
                <mat-optgroup [label]="group.key">
                    @for (item of group.items; track item._id) {
                    <mat-option [value]="item">
                        {{item.name}}
                    </mat-option>
                    }
                </mat-optgroup>
                }
            </mat-autocomplete>
            <mat-hint>
                <strong>{{meta().info}}</strong>
            </mat-hint>
            @if (formControl()?.hasError('picker')) {
            <mat-error>
                {{meta()?.name}} is required.
            </mat-error>
            }
        </mat-form-field>
    </div>
    <div class="prototypes" [formArray]="pickerArray!">
        @for (prototype of nodes; track prototype._id; let i = $index) {
        @if (!!prototype) {
        <mat-form-field class="form-field">
            <input readonly matInput [formControl]="$any($safeNavigationMigration(pickerArray?.at(i)))">
            @if (!meta()?.disabled) {
            <button matSuffix mat-icon-button aria-label="Clear" (click)="onDelete(i)">
                <mat-icon>close</mat-icon>
            </button>
            }
            <mat-hint><strong>Prototype - {{prototype.name}}</strong></mat-hint>
        </mat-form-field>
        }
        }
    </div>
</div>
}
